// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2715":"b8a11a98cbb6bfb5","3942":"c5a14c9ba4aaa32d","4213":"008db7e95348873d","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};